import { render, staticRenderFns } from "./TableListAccessGroups.vue?vue&type=template&id=08118604"
import script from "./TableListAccessGroups.vue?vue&type=script&lang=js"
export * from "./TableListAccessGroups.vue?vue&type=script&lang=js"
import style0 from "./TableListAccessGroups.vue?vue&type=style&index=0&id=08118604&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08118604')) {
      api.createRecord('08118604', component.options)
    } else {
      api.reload('08118604', component.options)
    }
    module.hot.accept("./TableListAccessGroups.vue?vue&type=template&id=08118604", function () {
      api.rerender('08118604', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableListAccessGroups.vue"
export default component.exports